<div class="modal-header ">
  <p class="modal-title" id="title"><strong>{{header}}</strong></p>
      <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="col-12">
    <label>{{message}}</label>
    <textarea class="form-control" maxlength="1000" [(ngModel)]="comment" rows="2" spellcheck="true">{{comment}}</textarea>
  </div>
  <div class="col-12" *ngIf="checkBoxLabel">
    <label><input type="checkbox" class="check-input mt-2" [(ngModel)]="candidateSent" /> {{checkBoxLabel}} </label>    
  </div>
  <div class="col-12 text-center mt-3">
    <button class="btn btn-outline-primary me-2" (click)="modal.dismiss()">Cancel</button>
    <button class="btn btn-secondary" [disabled]="!canConfirm()" (click)="modal.close({'Comment':comment,'CandidateSent':candidateSent})">Confirm</button>

  </div>
</div>
